import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../../orchestrator';
import { useAppDispatch } from '../../../../stores/redux.store';
import { handleMfaPromoteUserSelection } from '../../../../actions/mfa-promote-actions';
import { useButtonClickedEvent } from '../../../../utilities/analytics/analytics-web-client';
import { pageId } from '../constants';

/**
 * Provides the handler for the "Enable two-step verification" button.
 * When called, it will trigger a server-driven redirect to the MFA setup flow.
 */
export const useEnableTwoStepVerification = () => {
  useRegisterComponent(useEnableTwoStepVerification.name);

  const dispatch = useAppDispatch();
  const { search } = useLocation();
  const trackMfaContinueButtonClicked = useButtonClickedEvent(pageId, 'MfaPromoteContinue');

  const onEnableTwoStepVerificationClicked = useCallback(() => {
    trackMfaContinueButtonClicked();
    dispatch(handleMfaPromoteUserSelection('edit_mfa', search));
  }, [dispatch, search, trackMfaContinueButtonClicked]);

  return { onEnableTwoStepVerificationClicked };
};
